import { IActiveTrayFilter } from '../../models/IActiveTrayFilter';
import { IBOMSearchFilter, IPartsSearchFilter } from '../../models/IBOMSearchFilter';
import { ICheckItemFilter } from '../../models/ICheckItemFilter';
import { IDefectiveItemFilter } from '../../models/IDefectiveItemFilter';
import IDefaultColumSortOrder from '../../models/IDefaultColumSortOrder';
import { IFactoryFilter } from '../../models/IFactoryFilter';
import { IGroupFilter } from '../../models/IGroupFilter';
import { IHKRSchdeuleFilter } from '../../models/IHKRScheduleFilter';
import { IKishuFilter } from '../../models/IKishuFilter';
import { IMaterialTagsFilter } from '../../models/IMaterialTagsFilter';
import { IOrderTableFilter } from '../../models/IOrderTableFilter';
import { IProcessFilter } from '../../models/IProcessFilter';
import { IProcessWiseChartFilter } from '../../models/IProcessWiseChartFilter';
import { IProductFilter } from '../../models/IProductFilter';
import { ITagsFilter } from '../../models/ITagsFilter';
import { ITeplarFilter } from '../../models/ITeplarFilter';
import { IToolCheckItemFilter } from '../../models/IToolCheckItemFilter';
import { IToolManagementFilter } from '../../models/IToolManagementFilter';
import { ITrayListFilter } from '../../models/ITrayFilter';
import { ITrayHistoryFilter } from '../../models/ITrayHIstoryFilter';
import { ITrayTagReassignFilter } from '../../models/ITrayTagReassignFilter';
import { IUserFilter } from '../../models/IUserFilter';
import { IUserLogsFilter } from '../../models/IUserLogsFilter';
import { INCReportFilter} from '../../models/INonconformanceReportFilter'

export const FactoryFilterInitialState: IFactoryFilter = {
  Column: 'factory_name',
  Order: 'asc',
  FactoryName: '',
  City: '',
  FactoryType: -1,
};

export const FactoryDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'FactoryName',
  order: 'asc',
};

export const TrayDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'TrayId',
  order: 'asc',
};

export const TrayFilterInitialState: ITrayListFilter = {
  Column: 'tray_id',
  Order: 'asc',
  TrayId: '',
  OrderId: '',
  EUOrderNo: '',
  CustomerDueDate: '',
  ProductId: '',
  CustomerId: '',
  IsComplete: false,
  IsDeleted: false
};

export const GroupDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'CustomerDueDate',
  order: 'asc',
};

export const GroupFilterInitialState: IGroupFilter = {
  TrayId: '',
  OrderId: '',
  ProductId: '',
  CustomerDueDate: '',
  Katashiki: '',
  Kishu: '',
  IsAssigned: '',
  EndUserOrderId: '',
  Column: 'CustomerDueDate',
  Order: 'asc',
  KeyInfo1: '',
  KeyInfo2: '',
  KeyInfo3: '',
  CustomerId: '',
};

export const ActiveTrayDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'CustomerDueDate',
  order: 'asc',
};

export const ActiveTrayFilterInitialState: IActiveTrayFilter = {
  Column: 'customer_due_date',
  Order: 'asc',
  TrayId: '',
  OrderId: '',
  EndUserOrderId: '',
  CustomerDueDate: '',
  PlanedDueDate: '',
  ProductId: '',
  CustomerId: '',
  Quantity: 0,
  MissingParts: '',
  ProductComment1: '',
  ProductComment2: '',
  ProductComment3: '',
  ProductComment4: '',
  ProductComment5: '',
  ProductComment6: '',
  Kishu: '',
  EndUserName: '',
  SubContractor: 0,
  ProcessName: '',
  ProcessDueDate: ''
};

export const ProcessWiseChartFilterInitialState: IProcessWiseChartFilter = {
  SubContractor: 0
};

export const UserFilterInitialState: IUserFilter = {
  FactoryName: '-1',
  Column: '',
  Order: '',
  UserType: '-1',
  UserName: '',
  UserId: '',
};

export const UserDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'UserName',
  order: 'asc',
};

export const ProcessFilterInitialState: IProcessFilter = {
  ProcessName: '',
  ProcessType: '-1',
  ShortName: '',
  Column: '',
  Order: '',
};

export const TrayTagReassignFilterInitialState: ITrayTagReassignFilter = {
  Column: '',
  Order: '',
  TrayId: ''
};


export const UserLogsFilterInitialState: IUserLogsFilter = {
  Factory: '',
  UserName: '',
  Action: '',
  Module:  -1,
  ActionDetail: '',
  StartDate: '',
  EndDate: '',
  Column: 'action_timestamp',
  Order: 'DESC',
};

export const UserLogsDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'action_timestamp',
  order: 'desc',
};

export const ProcessDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ProcessName',
  order: 'asc',
};

export const TrayTagReassignColumnSortOrder: IDefaultColumSortOrder = {
  dataField: 'ProcessName',
  order: 'asc',
};

export const HKRScheduleFilterInitialState: IHKRSchdeuleFilter = {
  Kishu: '',
  Code: '',
  StartTime: '',
  EndTime: '',
  Column: 'ProcessDueDate',
  Order: 'asc',
};

export const HKRSchdefuleDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ProcessDueDate',
  order: 'asc',
};

export const KishuDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'KishuName',
  order: 'asc',
};

export const KishuFilterInitialState: IKishuFilter = {
  KishuName: '',
  KishuType: '-1',
  ShortName: '',
  Column: '',
  Order: '',
};

export const TagsFilterInitialState: ITagsFilter = {
  EndUserId: '',
  Group: '',
  TrayId: '',
  Column: '',
  Order: '',
};

export const TagFilterDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'Group',
  order: 'asc',
};

export const TrayHistoryFilterInitialState: ITrayHistoryFilter = {
  Column: 'start_date',
  Order: 'asc',
  StartDate: '',
  EndDate: '',
};

export const TrayHistoryDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'StartDate',
  order: 'asc',
};

export const TeplarFilterInitialState: ITeplarFilter = {
  Katashiki: '',
  ProductId: '',
  Format: '',
  Column: '',
  Order: 'asc',
};

export const TeplarDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ProductId',
  order: 'asc',
};

export const ProductFilterInitialState: IProductFilter = {
  Katashiki: '',
  ProductId: '',
  Column: '',
  Order: 'asc',
  CreatedBy: '',
  CreatedDate: '',
  UpdatedBy: '',
  UpdatedDate: '',
};

export const ProductDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ProductId',
  order: 'asc',
};

export const OrderTableFilterInitialState: IOrderTableFilter = {
  Column: 'TrayId',
  Order: 'asc',
  TrayId: '',
  OrderId: '',
  CustomerDueDate: '',
  EUOrderNo: '',
  PlanedDueDate: '',
  ProductId: '',
  CustomerId: '',
  EndUserName: '',
  Kishu: '',
  Katashiki1: '',
  Katashiki2: '',
  ShowAssigned: false,
  Quantity: '',
  ProcessId: -3,
  SubContractor: '',
  IsTrayCompleted: false,
  MaterialProductId: '',
  MaterialKatashiki: '',
};

export const OrderTableDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'TrayId',
  order: 'asc',
};

export const CheckItemFilterInitialState: ICheckItemFilter = {
  ProcessName: '',
  TemplateName: '',
  Column: 'ProcessName',
  Order: 'asc',
};

export const CheckItemDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ProcessName',
  order: 'asc',
};

export const BOMFilterInitialState: IBOMSearchFilter = {
  NextProcess: '-3',
  StartDate: '',
  EndDate: '',
  MaterialKatashiki: '',
  MaterialClassificationValue: '',
  FreeTextSearch: '',
  Column: 'MaterialProductId',
  Order: 'asc',
  SubContractorName: ''
}

export const BOMDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'MaterialProductId',
  order: 'asc',
};

export const MaterialTagsFilterInitialState: IMaterialTagsFilter = {
  MaterialProductId: '',
  Column: '',
  Order: '',
};

export const PartsSearchFilterInitialState: IPartsSearchFilter = {
  NextProcess: '-3',
  StartDate: '',
  EndDate: '',
  MaterialKatashiki: '',
  MaterialClassificationValue: '',
  FreeTextSearch: '',
  Column: 'TrayId',
  Order: 'asc',
  SubContractorName: ''
}

export const PartsSearchDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'TrayId',
  order: 'asc',
};

export const ToolManagementFilterInitialState: IToolManagementFilter = {
  OwnerFactoryId: '-1',
  ToolManagementNo: '',
  ToolName: '',
  SerialNo: '',
  InspectionStatus: '-1',
  CalibrationStatus: '-1',
  UsageStatus: '-1',
  Column: 'tool_management_no',
  Order: 'asc',
};

export const ToolManagementDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'ToolManagementNo',
  order: 'asc',
};

export const DefectiveItemDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'Subject',
  order: 'asc',
};

export const DefectiveItemFilterInitialState: IDefectiveItemFilter = {
  Subject: '',
  Item: '',
  Classification: '',
  Classification2: ''
};

export const ToolCheckItemFilterInitialState: IToolCheckItemFilter = {
  TemplateName: '',
  Column: 'CheckItemName',
  Order: 'asc',
};

export const ToolCheckItemDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'CheckItemName',
  order: 'asc',
};

export const CrimpingInspectionRecordDefaultSortColumnOrder: IDefaultColumSortOrder = {
  dataField: 'InspectionDateTime',
  order: 'desc',
};

export const NCReportFilterInitialState: INCReportFilter = {
  StartDate: null,
  EndDate: null,
};
